import axios from "axios";

export default {
  name: "umpd",
  state: {
    listSppdDetail: [],
  },
  getters: {
    getDetailSppd: (state) => {
      return state.listSppdDetail;
    },
  },
  mutations: {
    setDetailSppd: (state, payload) => {
      state.listSppdDetail = payload.list_nama_item;
    },
  },
  actions: {
    fetchSppdDetail(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "klaim_biaya_pd/sppd_detil",
          params: {
            id_sppd: params.id_sppd,
            id_klaim_draft: params.id_klaim_draft,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            store.commit('setDetailSppd', data)
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
